<template>
  <div
    :class="{
      group: true,
      collapse: collapsible,
      shown: !internalCollapsed,
      hidden: internalCollapsed
    }">
    <h2
      v-if="header"
      class="header group__header"
      v-on="collapsible ? { click: onClickCollapse } : {}">
      <button
        v-if="collapsible"
        type="button"
        class="collapse-icon"
        :aria-expanded="!internalCollapsed"
        :aria-label="internalCollapsed ? 'Show ' + header : 'Hide ' + header">
        <span
          :class="{
            'ui-icon': true,
            'ui-icon-triangle-1-n': !internalCollapsed,
            'ui-icon-triangle-1-s': internalCollapsed
          }"></span>
      </button>
      <span class="header__text">{{ header }}</span>
    </h2>
    <div class="rect group__inner">
      <slot></slot>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GroupComponent',
  props: {
    header: String,
    collapsed: Boolean,
    collapsible: Boolean
  },
  data() {
    return {
      internalCollapsed: this.collapsed
    }
  },
  watch: {
    collapsed() {
      if (this.internalCollapsed !== this.collapsed) {
        this.internalCollapsed = this.collapsed
      }
    }
  },
  methods: {
    onClickCollapse(ev) {
      ev.preventDefault()
      ev.stopPropagation()
      this.internalCollapsed = !this.internalCollapsed
    }
  }
}
</script>
